import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
const Checkbox = ({ checked, ...props }) => <FontAwesomeIcon icon={checked ? faCheckSquare : faSquare} {...props} />;

export default Checkbox;
